import type { UserConfig } from 'next-i18next/pages'
import path from 'path'

import localeConfig from './config/localeConfig.json' with { type: 'json' }
import { handleMissingTranslation } from './src/utils/i18n-missing-key-reporter'

const locales = localeConfig.map(({ origin, transform }) => transform || origin)

export default {
  i18n: {
    localeDetection: false,
    locales: ['default', ...locales],
    defaultLocale: 'default',
  },
  fallbackLng: false,
  defaultNS: 'fitify-web-onboarding',
  localePath:
    typeof window === 'undefined'
      ? path.resolve('./public/static/locales')
      : '/static/locales',
  react: {
    transKeepBasicHtmlNodesFor: ['br', 'b', 'strong', 'i'],
    transSupportBasicHtmlNodes: true,
  },
  saveMissing: true,
  missingKeyHandler: handleMissingTranslation,
  serializeConfig: false,
} satisfies UserConfig
